import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICONS } from '../../icons';

export default function AdminSidebar({ tabs, activeTab, onTabChange }) {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  return (
    <aside className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="admin-sidebar-header">
        <div className="admin-sidebar-logo">
          <FontAwesomeIcon icon={ICONS.SHIELD_ALT} />
        </div>
        {!collapsed && (
          <div className="admin-sidebar-brand">
            <h2>Admin Portal</h2>
            <span className="admin-sidebar-badge">Administrator</span>
          </div>
        )}
      </div>

      <nav className="admin-sidebar-nav">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`admin-sidebar-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            title={collapsed ? tab.label : undefined}
          >
            <FontAwesomeIcon icon={tab.icon} className="sidebar-item-icon" />
            {!collapsed && <span className="sidebar-item-label">{tab.label}</span>}
            {tab.count !== undefined && (
              <span className={`sidebar-item-count ${collapsed ? 'collapsed' : ''}`}>
                {tab.count}
              </span>
            )}
          </button>
        ))}

        <div className="admin-sidebar-divider" />

        <button
          className="admin-sidebar-item dashboard-link"
          onClick={() => navigate('/dashboard')}
          title={collapsed ? 'Dashboard' : undefined}
        >
          <FontAwesomeIcon icon={ICONS.HOME} className="sidebar-item-icon" />
          {!collapsed && <span className="sidebar-item-label">Dashboard</span>}
        </button>
      </nav>

      <div className="admin-sidebar-footer">
        {!collapsed && <span className="sidebar-version">v{process.env.REACT_APP_VERSION?.replace('v', '') || '0.0.0'}</span>}
        <button
          className="sidebar-collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <FontAwesomeIcon icon={collapsed ? ICONS.CHEVRON_RIGHT : ICONS.CHEVRON_LEFT} />
        </button>
      </div>
    </aside>
  );
}
